import React from 'react';
import ListItemIcon, { ListItemIconProps } from '@material-ui/core/ListItemIcon';
import { UdsFC } from '../../types';

export const MenuListItemIcon: UdsFC<ListItemIconProps> = (props) => <ListItemIcon {...props} />;
